export const getInitialsFromName = (name: string) =>
    name
        .split(/[\s-]/)
        .map((name) => name[0])
        .join('');
